// Cycler "Aa" del topbar — port literal del helper de mockups/shared.js.
// Persiste el nivel en localStorage; CSS deriva todos los --fs-* de --fs-scale.

const FS_LEVELS = [
  { scale: 0.90, label: 'A−', hint: 'Texto pequeño' },
  { scale: 1.00, label: 'A',  hint: 'Texto normal' },
  { scale: 1.15, label: 'A+', hint: 'Texto grande' },
  { scale: 1.30, label: 'A⁺', hint: 'Texto extra' },
];
const FS_KEY = 'picking.fsLevel';

function _read() {
  const v = parseInt(localStorage.getItem(FS_KEY) ?? '1', 10);
  return Number.isFinite(v) && v >= 0 && v < FS_LEVELS.length ? v : 1;
}
function _apply(idx) {
  document.documentElement.style.setProperty('--fs-scale', FS_LEVELS[idx].scale);
}

/** Aplica al cargar el nivel guardado, antes del primer render. */
export function initFontScale() { _apply(_read()); }

/** Botón inline para meter en el topbar (HTML string).
 *  Llamar bindFontScaleCycler() después de insertarlo. */
export function fontScaleButtonHTML() {
  const cur = _read();
  return `<button class="iconbtn --fs" id="fs-cycler" aria-label="Tamaño de letra" title="Tamaño de letra">${FS_LEVELS[cur].label}</button>`;
}

/** Activa el cycler globalmente — basta llamarlo una vez al arrancar la app.
 *  Como usa delegación, sigue funcionando aunque el botón se re-renderice. */
export function bindFontScaleCycler() {
  if (window.__pickingFsBound) return;
  window.__pickingFsBound = true;
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('#fs-cycler');
    if (!btn) return;
    const next = (_read() + 1) % FS_LEVELS.length;
    localStorage.setItem(FS_KEY, String(next));
    _apply(next);
    btn.textContent = FS_LEVELS[next].label;
    const hint = document.createElement('div');
    hint.className = 'fs-hint';
    hint.textContent = FS_LEVELS[next].hint;
    document.body.appendChild(hint);
    setTimeout(() => hint.remove(), 900);
  });
}
